import React from 'react';
import { useTranslation } from 'react-i18next';
import GreenArrow from '../../../../assets/icons/dashboard/greenArrow.svg';
import { getUnixTime } from 'date-fns';
import { bigIntToInt } from '../../../../helpers/numbers';

export const Statistics = ({ stats }) => {
  const { t } = useTranslation();
  const now = getUnixTime(new Date());
  const twentyFourHoursAgo = now - 24 * 60 * 60;

  // Подсчет новых пользователей за последние 24 часа
  const newUsers24 = stats?.totalUsers24Timestamp?.filter(
    (timestamp) => Number(timestamp) >= twentyFourHoursAgo && Number(timestamp) <= now
  ).length || 0;

  // Подсчет токенов X2 за последние 24 часа
  const x2Tokens24 = stats?.x2TotalTokens24Timestamp?.reduce((sum, timestamp, index) => {
    const ts = Number(timestamp) || 0;
    const isLast24Hours = ts >= twentyFourHoursAgo && ts <= now;
    const value = isLast24Hours ? (bigIntToInt(stats?.x2TotalTokens24Data?.[index]) || 0) : 0;
    return sum + value;
  }, 0) || 0;

  // Подсчет токенов X4 за последние 24 часа
  const x4Tokens24 = stats?.x4TotalTokens24Timestamp?.reduce((sum, timestamp, index) => {
    const ts = Number(timestamp) || 0;
    const isLast24Hours = ts >= twentyFourHoursAgo && ts <= now;
    const value = isLast24Hours ? (bigIntToInt(stats?.x4TotalTokens24Data?.[index]) || 0) : 0;
    return sum + value;
  }, 0) || 0;

  const dayProfit = (x2Tokens24 + x4Tokens24).toFixed(0);

  const statisticsList = [
    {
      title: t('dashboard.recentActivity.stats.users'),
      value: stats?.totalUsers,
      newValue: newUsers24,
    },
    {
      title: t('dashboard.recentActivity.stats.totalProfit'),
      value: ((Number(stats?.x2TotalTokens) + Number(stats?.x4TotalTokens)) / 1e18).toFixed(0),
      newValue: dayProfit,
    },
  ];

  return (
    <div className="flex items-center space-x-[2rem] lg:flex-col lg:space-x-0 lg:space-y-[1.2rem]">
      {statisticsList.map((item, itemIndex) => {
        return (
          <div
            className="flex items-center justify-between w-full h-[7.2rem] px-[2rem] rounded-[2rem] border-[0.1rem] border-solid border-white-50 bg-black-300 lg:h-full lg:flex-col lg:items-start lg:py-[2rem] lg:space-y-[1.2rem] lg:bg-white-30"
            key={itemIndex}
          >
            <span className="text-[1.4rem] font-500 text-white-500">{item?.title}</span>
            <div className="flex items-center space-x-[1rem]">
              <span className="text-[2rem] font-600 text-white leading-normal">{item?.value}</span>
              {item?.newValue && (
                <div className="flex items-center justify-center space-x-[0.5rem]">
                  <img src={GreenArrow} />
                  <span className="text-[#51F689] text-[1.4rem] font-400 leading-none">{item?.newValue}</span>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
